import { render, staticRenderFns } from "./BrandReviews.vue?vue&type=template&id=210097de&scoped=true"
import script from "./BrandReviews.vue?vue&type=script&lang=js"
export * from "./BrandReviews.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./BrandReviews.vue?vue&type=style&index=1&id=210097de&prod&scoped=true&lang=css"
import style2 from "./BrandReviews.vue?vue&type=style&index=2&id=210097de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210097de",
  null
  
)

export default component.exports